module.exports = __webpack_public_path__ + "static/12-2fe419a9cc4f9a29870afc31c073c92f.jpg";